import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SnackbarData } from '../snackbar/snackbar.component';

@UntilDestroy()
@Component({
  selector: 'app-workspace-add-docs-snackbar',
  templateUrl: './workspace-add-docs-snackbar.component.html',
  styleUrls: ['./workspace-add-docs-snackbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class WorkspaceAddDocsSnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: WorkspaceAddDocsSnackbarData,
    public snackBarRef: MatSnackBarRef<WorkspaceAddDocsSnackbarComponent>,
    public router: Router,
  ) {}

  close() {
    this.snackBarRef.dismiss();
  }

  viewWorkspace() {
    this.router.navigate(['/workspaces', this.data.uniqueId]);
  }
}

export interface WorkspaceAddDocsSnackbarData extends SnackbarData {
  uniqueId: string;
}
